import EditableImageUploadDropzone from "./EditableImageUploadDropzone";
import {
  useAccountData,
  useCachedFirebaseCrud
} from "../../../helpers/firebase";
import { uploadImageToImageResizerIo } from "../../../helpers/image-resizer";
import { fetchOurApi } from "../../../helpers/utils/apiCalls";

const LogoUploadDropzone = ({
  logoField = "logoUrl",
  imageName = "company logo",
  ...props
}) => {
  const [{ branding, cnaught }, companyDataLoading] = useAccountData();
  const logoUrl = branding?.[logoField];

  const { updateAccountData } = useCachedFirebaseCrud();

  const saveLogo = async (image) => {
    const { error, success, imageData } =
      await uploadImageToImageResizerIo(image);

    if (error || !success || !imageData) {
      return;
    }

    const { id } = imageData;
    const newLogoUrl = `https://im.ages.io/${id}?width=500`;

    await updateAccountData({ [`branding.${logoField}`]: newLogoUrl });

    const { subaccountId } = cnaught || {};
    if (logoField === "logoUrl" && subaccountId) {
      await fetchOurApi({
        path: "/integrations/cNaught/update-subaccount-logo",
        method: "POST",
        data: { subaccountId, logoUrl: newLogoUrl }
      });
    }
  };

  return (
    <EditableImageUploadDropzone
      onSave={saveLogo}
      imageName={imageName}
      imageUrl={logoUrl}
      isLoading={companyDataLoading}
      backgroundSize="contain"
      previewImageStyle={{ backgroundSize: "contain" }}
      {...props}
    />
  );
};
export default LogoUploadDropzone;
